import { combineReducers } from "redux";
import allapireducer from "./../AllApi/reducer";
export default combineReducers({
  allapi: allapireducer,
});
